var map = {
	"./Deutsche_Post.png": "7549",
	"./Logo_dark.svg": "58c5",
	"./Logo_white.svg": "c2e9",
	"./Text_Logo_White.svg": "b6f5",
	"./arrow.svg": "27e4",
	"./basket.png": "8b22",
	"./chat.png": "ffb1",
	"./checkmark-p-500.png": "3608",
	"./checkmark.png": "8f85",
	"./complete-set.png": "aba9",
	"./configurator.png": "a055",
	"./contacts.png": "12bd",
	"./countersink.png": "4a06",
	"./esther-jiao-640129-unsplash.jpg": "4060",
	"./favicon.png": "8925e",
	"./head-adapter.png": "c71b",
	"./icons8-company.png": "82a6",
	"./icons8-contact-96.png": "6aa7",
	"./icons8-customer.png": "1494",
	"./icons8-epub.png": "d818",
	"./icons8-hashtag_large.png": "76aa",
	"./icons8-idea-96.png": "6c29",
	"./icons8-job-seeker-96.png": "8d74",
	"./icons8-overview-96.png": "cd91",
	"./icons8-presentation.png": "9d57",
	"./icons8-purchase-order-96.png": "b127",
	"./icons8-screw-96.png": "d92d",
	"./icons8-secured-letter-48.png": "cd9a",
	"./icons8-shopping-cart-96.png": "a81a",
	"./icons8-shutdown-48.png": "b488",
	"./icons8-slider-96.png": "159e",
	"./icons8-speech.png": "ad00",
	"./icons8-user-group-96.png": "e379",
	"./icons8-view-more-96.png": "36ff",
	"./idea.png": "542e",
	"./letter.png": "e245",
	"./linkedin.png": "beb0",
	"./linkedin_circle-512.png": "5dd9",
	"./loading.gif": "12ae",
	"./logo-white.svg": "a266",
	"./logo.png": "9d64",
	"./orders.png": "e438",
	"./profile.png": "b31e",
	"./ruler-combined-solid.svg": "58e2",
	"./screw.png": "27ee",
	"./shop.png": "58f6",
	"./shutdown.png": "7696",
	"./speech.png": "2483",
	"./star.svg": "dbfd",
	"./stripe-grey.svg": "291a",
	"./tube-adapter.png": "c684",
	"./tube-fixator.png": "8a5a",
	"./unchecked.png": "f635",
	"./user-1.png": "5b3c",
	"./webclip.png": "6edc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";